import enMessages from '../locales/da_DA.json';

const EnLang = {
  messages: {
    ...enMessages
  },
  locale: 'da',
};
export default EnLang;
